import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7dbc4380")

_pushScopeId("data-v-7dbc4380")
const _hoisted_1 = { class: "font-montserrat" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col gap-3"
}
const _hoisted_3 = { class: "flex justify-between items-start gap-6" }
const _hoisted_4 = { class: "flex flex-col gap-2 w-full" }
const _hoisted_5 = { class: "flex flex-col items-end gap-2 w-40" }
const _hoisted_6 = { class: "flex flex-col gap-2" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "gradient font-semibold text-xl flex items-center justify-between w-full text-red-lp-100 font-montserrat" }
const _hoisted_9 = {
  key: 0,
  class: "text-base"
}
const _hoisted_10 = { class: "table-content-scrollable font-montserrat flex flex-col gap-2.5" }
const _hoisted_11 = { class: "flex items-center justify-between w-full text-sm font-semibold text-gray-lp-2700" }
const _hoisted_12 = { class: "flex items-center gap-2 flex-1" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, "No. STT", -1)
const _hoisted_14 = { class: "flex-1 flex items-center gap-2 justify-between" }
const _hoisted_15 = { class: "flex items-center gap-2 flex-1" }
const _hoisted_16 = { class: "flex-1 font-bold" }
const _hoisted_17 = { class: "flex-1 flex items-center gap-2 justify-between" }
const _hoisted_18 = { class: "font-light text-black-lp-200" }
const _hoisted_19 = { class: "font-bold text-red-lp-100" }
const _hoisted_20 = {
  key: 1,
  class: "w-full text-sm border-gray-lp-1400 grid grid-cols-2 gap-4"
}
const _hoisted_21 = { class: "flex-1 text-black-lp-100 font-light" }
const _hoisted_22 = { class: "flex-1 flex items-center gap-2 text-black-lp-200 justify-end font-semibold" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.skeletonCount, (n) => {
            return (_openBlock(), _createBlock("div", {
              key: n,
              class: "rounded-xl border border-gray-lp-1400 bg-white p-4 flex flex-col gap-4 animate-pulse"
            }, [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_Skeleton, {
                    height: "18px",
                    width: "35%"
                  }),
                  _createVNode(_component_Skeleton, {
                    height: "14px",
                    width: "55%"
                  })
                ]),
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_Skeleton, {
                    height: "16px",
                    width: "80%"
                  }),
                  _createVNode(_component_Skeleton, {
                    height: "16px",
                    width: "60%"
                  })
                ])
              ]),
              _createVNode("div", _hoisted_6, [
                (_openBlock(), _createBlock(_Fragment, null, _renderList(3, (i) => {
                  return _createVNode(_component_Skeleton, {
                    key: i,
                    height: "32px",
                    width: "100%"
                  })
                }), 64))
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode(_component_Accordion, {
            id: "accordion-reconcile-summary",
            activeIndex: _ctx.displayType === 'money' ? null : 0,
            class: _ctx.displayType !== 'money' && 'hidden-icon'
          }, {
            default: _withId(() => [
              _createVNode(_component_AccordionTab, null, {
                header: _withId(() => [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("span", null, _toDisplayString(_ctx.title), 1),
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.totalString) + " ", 1),
                      (_ctx.subtotalString)
                        ? (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(_ctx.subtotalString), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                default: _withId(() => [
                  _createVNode("div", _hoisted_10, [
                    (_ctx.displayType === 'money')
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _createVNode("div", _hoisted_11, [
                            _createVNode("div", _hoisted_12, [
                              _hoisted_13,
                              _createVNode("div", _hoisted_14, [
                                _createVNode("div", null, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.serviceType")), 1),
                                _createVNode("div", null, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.nominal")), 1)
                              ])
                            ])
                          ]),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
                            return (_openBlock(), _createBlock("div", {
                              key: item,
                              class: "flex items-center justify-between w-full text-sm pt-2.5 border-t border-gray-lp-1400"
                            }, [
                              _createVNode("div", _hoisted_15, [
                                _createVNode("div", _hoisted_16, _toDisplayString(item.sttNo), 1),
                                _createVNode("div", _hoisted_17, [
                                  _createVNode("div", _hoisted_18, _toDisplayString(item.serviceType), 1),
                                  _createVNode("div", _hoisted_19, _toDisplayString(item.amount), 1)
                                ])
                              ])
                            ]))
                          }), 128))
                        ], 64))
                      : (_openBlock(), _createBlock("div", _hoisted_20, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
                            return (_openBlock(), _createBlock("div", { key: item }, [
                              _createVNode("div", {
                                class: ["flex items-center gap-2 flex-1 ", `${index % 2 === 0 ? '' : ' border-l border-gray-lp-1400 pl-4'}`]
                              }, [
                                _createVNode("div", _hoisted_21, _toDisplayString(item.sttStatus), 1),
                                _createVNode("div", _hoisted_22, [
                                  _createVNode("div", null, _toDisplayString(item.sttAmount) + " STT", 1),
                                  _createVNode("div", null, "(" + _toDisplayString(item.koliAmount) + " " + _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.koli")) + ") ", 1)
                                ])
                              ], 2)
                            ]))
                          }), 128))
                        ]))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["activeIndex", "class"])
        ]))
  ]))
})